"use client";

import React from "react";
import styles from "./index.module.css";
import { Button } from "antd";
import Image from "next/image";
import StartBuildingButton from "@/components/Home/Hero/StartBuildingButton";
import { API_DOCS_URL } from "@/constant/common";

const Hero = () => {
  const integrationReadyText = "One platform. Every API.";
  const h1Text = "Instant APIs for developers — ";
  const h1PoweredByText = "go live in minutes, not weeks";
  const descriptionText =
    "Ready-to-use communication and data APIs — SMS, email, address validation, fax, IP geolocation, and analytics. Instant provisioning, reliable delivery, built-in compliance, and transparent logs, all behind one key.";
  const docButtonText = "Documentation";
  const subtitleText = "Built for developers";
  const h2Text = "Built for speed, reliability, compliance";
  const advantage1Value = "5×";
  const advantage1Description =
    "Faster to launch than wiring up each integration yourself";
  const advantage2Value = "99.95%";
  const advantage2Description =
    "Delivery & uptime across every API on the platform";
  const advantage3Value = "1 key";
  const advantage3Description =
    "One key, one dashboard, one invoice — no glue code";

  return (
    <>
      <div className={styles.background}>
        <section className={styles.section}>
          <div className={styles.hero}>
            <div className={styles.content}>
              <div className={styles.integrationReady}>
                <Image
                  src="/images/home/star.svg"
                  alt=""
                  width={13.5}
                  height={15}
                />
                <p className={styles.apiText}>{integrationReadyText}</p>
              </div>
              <h1>
                {h1Text}
                <span className={styles.highlight} style={{ display: "block" }}>
                  {h1PoweredByText}
                </span>
              </h1>
              <p>{descriptionText}</p>
              <div className={styles.actions}>
                <Button
                  type="default"
                  className={styles.playgroundButton}
                  onClick={() => window.open(API_DOCS_URL)}
                >
                  {docButtonText}
                </Button>
                <StartBuildingButton />
              </div>
            </div>
          </div>

          <div className={styles.advantages}>
            <div className={styles.container}>
              <div className={styles.intro}>
                <p className={styles.subtitle}>{subtitleText}</p>
                <h2>{h2Text}</h2>
              </div>
              <div className={styles.grid}>
                <div className={styles.card}>
                  <h3>{advantage1Value}</h3>
                  <p>{advantage1Description}</p>
                </div>
                <div className={styles.card}>
                  <h3>{advantage2Value}</h3>
                  <p>{advantage2Description}</p>
                </div>
                <div className={styles.card}>
                  <h3>{advantage3Value}</h3>
                  <p>{advantage3Description}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Hero;
